import { render, staticRenderFns } from "./MerchandisingFieldsMapper.vue?vue&type=template&id=aee45892"
import script from "./MerchandisingFieldsMapper.vue?vue&type=script&lang=js"
export * from "./MerchandisingFieldsMapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports